import { HttpClient, HttpEvent, HttpParams, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { enpointCervinoWeb } from 'src/app/configuration/enpointsCervino';
import { BranchModel } from 'src/app/models/management/branch.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BranchService {

  constructor(private _httpClient: HttpClient) { }

  attachConditions(branchId: number, rentalAttach: boolean, files: FormData): Observable<BranchModel> {
    const params = new HttpParams().set('branchId', branchId).set('rentalAttach', rentalAttach);
    return this._httpClient.post<BranchModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.AttachConditionsAsync}`,
      files, { params: params });
  }

  createBranch(branchContractModel: BranchModel): Observable<BranchModel> {
    return this._httpClient.post<BranchModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.CreateBranch}`,
      branchContractModel);
  }

  deleteBranch(branchId: number): Observable<BranchModel> {
    return this._httpClient.delete<BranchModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.DeleteBranch}/${branchId}`);
  }

  deleteAttachConditions(branchId: number, rentalAttach: boolean): Observable<BranchModel> {
    const params = new HttpParams().set('branchId', branchId).set('rentalAttach', rentalAttach);
    return this._httpClient.delete<BranchModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.DeleteAttachConditionsAsync}`,
      { params: params });
  }

  downloadConditions(branchId: number, rentalAttach: boolean): Observable<HttpEvent<Blob>> {
    const params = new HttpParams().set('branchId', branchId).set('rentalAttach', rentalAttach);
    return this._httpClient.request(new HttpRequest('GET', `${environment.apiCervinoBackend}${enpointCervinoWeb.branch.DownloadConditionsAsync}`,
      null, { params: params, reportProgress: true, responseType: 'blob' }));
  }

  getAllBranchByCompanyId(companyId: number): Observable<Array<BranchModel>> {
    return this._httpClient.get<Array<BranchModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.GetAllBranchByCompanyId}/${companyId}`);
  }

  getAllBranchesForSelectAsync(): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.GetAllBranchesForSelectAsync}`,);
  }

  GetAllBranchesByCompanyIdForSelectAsync(companyId: number): Observable<Array<any>> {
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.GetAllBranchesByCompanyIdForSelectAsync}/${companyId}`,);
  }

  getAllBranchesWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.GetAllBranchesWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getAllStoreForSelectAsync(branchId: number): Observable<Array<any>> {
    let params = new HttpParams();
    params = params.set('branchId', branchId);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.GetAllStoreForSelectAsync}`,
      { params: params });
  }

  getBranchByCode(code: number): Observable<BranchModel> {
    return this._httpClient.get<BranchModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.GetBranchByCode}/${code}`)
  }

  getBranchById(branchId: number): Observable<BranchModel> {
    return this._httpClient.get<BranchModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.GetByIdAsync}/${branchId}`);
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.GetColumnsForGeneralConsultationAsync}`);
  }

  getConditionsFilesAsync(branchId: number, rentalAttach: boolean): Observable<Array<any>> {
    const params = new HttpParams().set('branchId', branchId).set('rentalAttach', rentalAttach);
    return this._httpClient.get<Array<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.GetConditionsFilesAsync}`, { params: params });
  }

  getFirstBranchByCompanyId(companyId: number): Observable<BranchModel> {
    return this._httpClient.get<BranchModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.GetFirstBranchByCompanyId}/${companyId}`);
  }

  getFirstBranchByKeysAsync(): Observable<BranchModel> {
    return this._httpClient.get<BranchModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.GetFirstBranchByKeysAsync}`);
  }

  getFirstBranchByUserAuthenticatedAsync(): Observable<BranchModel> {
    return this._httpClient.get<BranchModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.GetFirstBranchByUserAuthenticatedAsync}`);
  }

  getLastBranchByKeysAsync(): Observable<BranchModel> {
    return this._httpClient.get<BranchModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.GetLastBranchByKeysAsync}`);
  }

  getNextBranchByKeysAsync(code: number): Observable<BranchModel> {
    const params = new HttpParams().set('code', code);
    return this._httpClient.get<BranchModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.GetNextBranchByKeysAsync}`,
      { params: params }
    );
  }

  getPreviusBranchByKeysAsync(code: number): Observable<BranchModel> {
    const params = new HttpParams().set('code', code);
    return this._httpClient.get<BranchModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.GetPreviusBranchByKeysAsync}`,
      { params: params }
    );
  }

  updateBranch(branchModel: BranchModel): Observable<BranchModel> {
    return this._httpClient.put<BranchModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.branch.UpdateBranch}`,
      branchModel);
  }
}
